<template>
  <div>
    <div class="content">
      <p class="content_title">上传贷款佐证文件</p>
      <van-uploader :before-read="beforeRead" v-model="fileList" multiple :max-count="10" :max-size="5 * 1024 * 1024" @oversize="onOversize" />
      <p class="instruction">
        上传要求：<br />
        1、佐证文件格式只支持图片JPG、png、jpeg<br />
      </p>
      <p class="description">
        贷后两个月内需上传贷款资金用途有效证明材料，包括并不限:<br />
        1、提供购销合同及与购销合同匹配的发票或收据或其他证明资金用途的佐证材料(其中提供发票的，发票开具日期应在购销合同之后，特殊情况需提供情况说明)<br />
        2、提供出入库单据、水电煤气费单据、人力工资等
      </p>
      <Button :loading="Isloading" loadingText="提交中..." text="提交" type="danger" :disabled="fileList.length<1 || Isloading" :click="submit" />
    </div>

  </div>
</template>
<script>
import Button from '@/components/Button.vue';
import { Toast } from 'vant';
export default {
  data() {
    return {

      Isloading: false,
      fileList: [],
    }
  },
  mounted() {
    this.getFileList()
  },
  components: {
    Button
  },
  methods: {
    getFileList(){
      this.$api.LoanSupermarket.queryDrawImage(this.$route.query.drawId).then((res) => {
      console.log(res)
      if (res.success) {
        this.fileList = res.data
      }
    }).catch((e) => {
      Toast('查询图片失败');
    });
    },
    // getFileFromUrl(url, fileName) {
    //   return new Promise((resolve, reject) => {
    //     var blob = null;
    //     var xhr = new XMLHttpRequest();
    //     xhr.open("GET", url);
    //     xhr.setRequestHeader('Accept', 'image/png');
    //     xhr.responseType = "blob";
    //     // 加载时处理
    //     xhr.onload = () => {
    //       // 获取返回结果
    //       blob = xhr.response;
    //       let file = new File([blob], fileName, { type: 'image/png' });
    //       // 返回结果
    //       resolve(file);
    //     };
    //     xhr.onerror = (e) => {
    //       reject(e)
    //     };
    //     // 发送
    //     xhr.send();
    //   });
    // },
    submit() {
      console.log(this.fileList)
      this.Isloading = true;
      const form = new FormData();
      form.append('orderId', this.$route.query.orderId);
      form.append('drawId', this.$route.query.drawId);
      for (const item of this.fileList) {
        if (item.file) {
          form.append('file', item.file);
        } else {
          form.append('repeatList', item.osskey);
        }
      }
      if(form.getAll('repeatList').length==0){form.append('repeatList', []);}
      if(form.getAll('file').length==0){form.append('file', null);}
      this.$api.LoanSupermarket.saveDrawImage(form).then((res) => {
        console.log(res)
        if (res.success) {
          Toast('提交成功');
          this.getFileList()
        } else {
          Toast('提交失败');
        }
        this.Isloading = false
      }).catch((e) => {
        Toast('提交失败');
        this.Isloading = false
      });
    },
    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 5M');
    },
    beforeRead(list) {
      console.log(list.length, this.fileList.length)
      if (list.length + this.fileList.length > 10) {
        Toast('文件数量不能超过10张');
        return false
      }
      return list
    }
  },
}
</script>
<style scoped>
.content {
  box-sizing: border-box;
  padding: 0 15px 15px 15px;
  background: #fff;
}
.content_title {
  margin: 0;
  padding: 13px 0;
  font-size: 17px;
  text-align: left;
}
.instruction {
  width: 250px;
  margin: 0 auto;
  padding: 16px 0 60px 0;
  font-size: 12px;
  color: #838d9b;
  text-align: left;
}
.description {
  font-size: 12px;
  color: #838d9b;
  text-align: left;
}
</style>
